/**
 * ``ThemeSync`` — headless component that reconciles the active theme with the user profile.
 *
 * Mounted once near the app root (inside the providers) so the profile theme is applied as
 * soon as ``GET /api/me/`` resolves, without blocking the first paint (ТЗ §7).
 */
import { useThemeProfileSync } from "./sync";

export function ThemeSync(): null {
  useThemeProfileSync();
  return null;
}
